import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

class EditName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      validationText: '',
      showValidationText: false,
    };
  }

  onChange = e => {
    this.setState({ value: e.target.value });
  };

  validation = () => {
    if (!this.state.value.length) {
      this.setState({
        showValidationText: true,
        validationText: 'Preencha o nome',
      });
      return false;
    }

    this.setState({
      showValidationText: false,
      validationText: '',
    });
    return true;
  };

  updateName = e => {
    e.preventDefault();
    if (this.validation()) {
      this.props.update(this.state.value);
    }
  };

  onBlur = () => {
    if (this.state.value === this.props.value) {
      this.props.close();
    }
  };

  render() {
    const validation = this.state.showValidationText ? 'error' : '';

    return (
      <div className="edit-view">
        <form onSubmit={this.updateName}>
          <input
            className={validation}
            maxLength={45}
            name={this.props.label}
            id="categoryName"
            value={this.state.value}
            onChange={this.onChange}
            onBlur={this.onBlur}
          />
          <Button bsStyle="success" type="submit" onClick={this.updateCategory}>
            Salvar
          </Button>
          <span className={`validationText ${this.state.showValidationText ? 'show' : ''}`}>
            {this.state.validationText}
          </span>
        </form>
      </div>
    );
  }
}

EditName.propTypes = {
  update: PropTypes.func,
  close: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string,
};

export default EditName;



// WEBPACK FOOTER //
// ./src/components/EditName/index.js